import { render, staticRenderFns } from "./CTAButton.vue?vue&type=template&id=9d0a252c&scoped=true&"
import script from "./CTAButton.vue?vue&type=script&lang=js&"
export * from "./CTAButton.vue?vue&type=script&lang=js&"
import style0 from "./CTAButton.vue?vue&type=style&index=0&id=9d0a252c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0a252c",
  null
  
)

export default component.exports